// @ts-nocheck
/* eslint-disable */
import { node } from "./utils";
import Melown3dCompass from "./compass";

export default class Melown3dFalloutCompass extends Melown3dCompass {
	/**
	 * Kompas ala fallout.
	 *
	 * @param {Function} [cb] Callback kliknuti na kompas
	 * @param {Object} [scope] Scope
	 *
	 */
	constructor(cb, scope, trans) {
		super(cb, scope, trans);

		this._const = {
			COMPASS_ORDER: ["N", "NE", "E", "SE", "S", "SW", "W", "NW", "N", "NE", "E", "SE", "S", "SW", "W", "NW", "N"],
			COMPASS_ANGLES: [{
				value: -180,
				item: "S",
				order: 0
			}, {
				value: -135,
				item: "SW",
				order: 0
			}, {
				value: -90,
				item: "W",
				order: 0
			}, {
				value: -45,
				item: "NW",
				order: 0
			}, {
				value: 0,
				item: "N",
				order: 1
			}, {
				value: 45,
				item: "NE",
				order: 1
			}, {
				value: 90,
				item: "E",
				order: 1
			}, {
				value: 135,
				item: "SE",
				order: 1
			}, {
				value: 180,
				item: "S",
				order: 1
			}],
			COMPASS_SIZES: {
				side: 30,
				line: 50,
				viewport: 250
			}
		};

		this._compassData = {};
		this._compassItems = null;

		this._build();
	}

	/**
	 * Zmena uhlu yaw - 0 sever, + SV, - SV, 0-360
	 *
	 * @param  {Number} yaw Uhel otoceni
	 */
	setYaw(yaw) {
		yaw = typeof yaw !== "number" ? 0 : -yaw;

		if (!this._compassItems) return;

		if (yaw < -180) {
			yaw += 360;
		}
		else if (yaw > 180) {
			yaw -= 360;
		}

		let len = this._const.COMPASS_ANGLES.length - 1;
		let fin = 0;

		for (let i = 0; i < len; i++) {
			let fromItem = this._const.COMPASS_ANGLES[i];
			let toItem = this._const.COMPASS_ANGLES[i + 1];

			if (yaw >= fromItem.value && yaw <= toItem.value) {
				let valueFrom = this._compassData[fromItem.item][fromItem.order];
				let valueTo = this._compassData[toItem.item][toItem.order];

				let dist = Math.abs(toItem.value - fromItem.value);
				let left = (yaw - fromItem.value) / dist;
				let right = 1 - left;

				fin = right * valueFrom + left * valueTo;
				break;
			}
		}

		this._compassItems.style.left = fin + "px";
	}

	/**
	 * Vytvoreni DOMu.
	 */
	_build() {
		// kompas
		let compass = node("div", { className: "fallout-compass" });
		let compassItems = node("div", { className: "items" });
		let compassCenter = node("div", { className: "center" });
		// svetove strany

		let left = 0;
		let langSides = (this._trans["worldSides"] || "").split("|");
		let langOrder = "N|NE|E|SE|S|SW|W|NW".split("|");
		let langSidesObj = {};

		langOrder.forEach((l, ind) => {
			langSidesObj[l] = langSides[ind];
		});

		let lastInd = this._const.COMPASS_ORDER.length - 1;

		this._const.COMPASS_ORDER.forEach((side, ind) => {
			let sideEl = node("span", { className: "side" });
			sideEl.textContent = langSidesObj[side];

			if (!(side in this._compassData)) {
				this._compassData[side] = [];
			}

			// ulozime index
			this._compassData[side].push(-left + this._const.COMPASS_SIZES.viewport / 2 - this._const.COMPASS_SIZES.side / 2);

			compassItems.appendChild(sideEl);
			left += this._const.COMPASS_SIZES.side;

			if (ind != lastInd) {
				let line = node("span", { className: "line" });

				left += this._const.COMPASS_SIZES.line;
				compassItems.appendChild(line);
			}
		});

		compass.appendChild(compassItems);
		compass.appendChild(compassCenter);

		// dame na sever
		compassItems.style.left = this._compassData.N[1] + "px"; // N je tam 3x, chceme stred, takze 1

		// kliknutim se dostaneme zpatky na sever
		compass.addEventListener("click", e => {
			this._runCb();
		});

		this._rootEl = compass;
		this._compassItems = compassItems;
	}
}
